import React from 'react';
import Footer from '../components/Footer';
import './Ambassador.css';
function Ambassador() {
  return <div className="page-ambassador">
      <div style={{
      position: 'absolute',
      width: 0,
      height: 0,
      overflow: 'hidden'
    }} aria-hidden="true">
        <>
          <svg width="13" height="11" viewBox="0 0 13 11" fill="none" id="svg-990040155_504">
            <path d="M13 7C13 9.78444 9.83064 11 6.81818 11C3.80572 11 0 7.36777 0 4.58333C0 1.7989 0.169356 0 3.18182 0C6.19428 0 10.7273 4.25 13 7Z" fill="url(#svg-990040155_504_paint0_linear_1876_2173)" />
            <defs>
              <linearGradient id="svg-990040155_504_paint0_linear_1876_2173" x1="12" y1="4.5" x2="-4.91189e-07" y2="5.5" gradientUnits="userSpaceOnUse">
                <stop stopColor="#063A58" />
                <stop offset="1" stopColor="#063656" />
              </linearGradient>
            </defs>
          </svg>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" id="svg-1324802642_1218">
            <path d="M13.3333 15C13.7754 15 14.1993 15.1756 14.5118 15.4882C14.8244 15.8008 15 16.2247 15 16.6667C15 16.2247 15.1756 15.8008 15.4882 15.4882C15.8007 15.1756 16.2246 15 16.6667 15C16.2246 15 15.8007 14.8244 15.4882 14.5119C15.1756 14.1993 15 13.7754 15 13.3334C15 13.7754 14.8244 14.1993 14.5118 14.5119C14.1993 14.8244 13.7754 15 13.3333 15ZM13.3333 5.00004C13.7754 5.00004 14.1993 5.17564 14.5118 5.4882C14.8244 5.80076 15 6.22468 15 6.66671C15 6.22468 15.1756 5.80076 15.4882 5.4882C15.8007 5.17564 16.2246 5.00004 16.6667 5.00004C16.2246 5.00004 15.8007 4.82445 15.4882 4.51189C15.1756 4.19932 15 3.7754 15 3.33337C15 3.7754 14.8244 4.19932 14.5118 4.51189C14.1993 4.82445 13.7754 5.00004 13.3333 5.00004ZM7.5 15C7.5 13.674 8.02679 12.4022 8.96447 11.4645C9.90215 10.5268 11.1739 10 12.5 10C11.1739 10 9.90215 9.47326 8.96447 8.53557C8.02679 7.59789 7.5 6.32612 7.5 5.00004C7.5 6.32612 6.97322 7.59789 6.03553 8.53557C5.09785 9.47326 3.82608 10 2.5 10C3.82608 10 5.09785 10.5268 6.03553 11.4645C6.97322 12.4022 7.5 13.674 7.5 15Z" fill="white" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" id="svg-392818195_1078">
            <path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12ZM16.814 9.581C16.8903 9.4741 16.9448 9.35323 16.9744 9.22527C17.004 9.09731 17.008 8.96478 16.9864 8.83524C16.9648 8.70571 16.9178 8.5817 16.8483 8.4703C16.7787 8.3589 16.6879 8.2623 16.581 8.186C16.4741 8.1097 16.3532 8.05521 16.2253 8.02562C16.0973 7.99604 15.9648 7.99195 15.8352 8.01359C15.7057 8.03522 15.5817 8.08216 15.4703 8.15172C15.3589 8.22128 15.2623 8.3121 15.186 8.419L10.872 14.459L8.707 12.293C8.5184 12.1108 8.2658 12.01 8.0036 12.0123C7.7414 12.0146 7.49059 12.1198 7.30518 12.3052C7.11977 12.4906 7.0146 12.7414 7.01233 13.0036C7.01005 13.2658 7.11084 13.5184 7.293 13.707L10.293 16.707C10.3957 16.8095 10.5195 16.8885 10.6558 16.9384C10.792 16.9883 10.9375 17.0079 11.0822 16.9959C11.2268 16.9839 11.3671 16.9406 11.4933 16.869C11.6195 16.7973 11.7286 16.699 11.813 16.581L16.814 9.581Z" fill="#2563EB" />
          </svg>
          <svg width="699" height="196" viewBox="0 0 699 196" fill="none" id="svg-1137231340_6119">
            <path d="M668.903 75.4492C685.462 75.4492 698.806 91.3256 699 111.098C699 111.195 699 111.39 699 111.488C699 111.682 699 111.877 699 111.975C698.806 131.747 685.462 147.623 668.903 147.623C668.027 147.623 667.15 147.623 666.176 147.526L666.079 147.428C659.163 146.649 653.904 140.805 653.904 133.792V129.604H647.865V137.299V147.623V162.501L626.826 177.72V111.488V75.4492H647.865V85.7737V93.4684H653.904V89.2801C653.904 82.2673 659.163 76.3258 666.079 75.5466H666.176C667.15 75.4492 668.027 75.4492 668.903 75.4492ZM662.767 126.585C671.144 126.682 677.962 119.864 677.962 111.488C677.962 103.208 671.144 96.3904 662.767 96.4878C654.683 96.5852 647.962 103.208 647.865 111.39V111.488C647.865 111.585 647.865 111.585 647.865 111.682C647.962 119.864 654.683 126.487 662.767 126.585Z" fill="#030319" />
            <path d="M583.064 75.4492C602.933 75.4492 619.102 91.6177 619.102 111.488C619.102 131.455 602.933 147.623 583.064 147.623C563.096 147.623 546.928 131.455 546.928 111.488C546.928 91.6177 563.096 75.4492 583.064 75.4492ZM583.064 126.585C591.343 126.585 598.063 119.864 598.063 111.488C598.063 103.208 591.343 96.4878 583.064 96.4878C574.687 96.4878 567.966 103.208 567.966 111.488C567.966 119.864 574.687 126.585 583.064 126.585Z" fill="#030319" />
            <path d="M488.334 147.623V60.5712L509.373 45.3523V147.623H488.334ZM518.431 147.623V58.9032L539.47 43.6843V147.623H518.431Z" fill="#030319" />
            <path d="M459.569 85.7737V75.4492H480.608V111.488V147.623H459.569V137.299V129.604H453.53V133.792C453.53 140.805 448.368 146.649 441.355 147.428H441.258C440.381 147.526 439.407 147.623 438.531 147.623C422.07 147.623 408.628 131.747 408.434 111.975C408.434 111.78 408.434 111.682 408.434 111.488C408.434 111.39 408.434 111.195 408.434 111C408.628 91.3255 422.07 75.4492 438.531 75.4492C439.407 75.4492 440.381 75.4492 441.258 75.5466H441.355C448.368 76.3258 453.53 82.2673 453.53 89.2801V93.4684H459.569V85.7737ZM459.569 111.682C459.569 111.585 459.569 111.585 459.569 111.488V111.39C459.472 103.208 452.848 96.5852 444.667 96.4878C436.29 96.3904 429.472 103.208 429.472 111.488C429.472 119.864 436.29 126.585 444.667 126.585C452.848 126.487 459.472 119.767 459.569 111.682Z" fill="#030319" />
            <path d="M365.433 96.4878C357.056 96.4878 350.336 103.208 350.336 111.488C350.336 119.864 357.056 126.585 365.433 126.585C371.569 126.585 376.926 122.883 379.166 117.526H400.984C398.159 134.571 383.257 147.623 365.433 147.623C345.465 147.623 329.297 131.455 329.297 111.488C329.297 91.6177 345.465 75.4492 365.433 75.4492C383.257 75.4492 398.159 88.4035 400.984 105.546H379.166C376.926 100.189 371.569 96.4878 365.433 96.4878Z" fill="#030319" />
            <path d="M281.603 66.6326C266.839 66.6326 260.844 71.4881 260.844 77.8003C260.844 89.745 321.687 81.7819 321.687 115.479C321.687 120.335 315.245 147.623 278.739 147.623C254.492 147.623 244.023 133.833 239.37 127.715L238.744 126.938L254.724 115.283C254.724 115.283 262.365 126.647 278.739 126.647C293.592 126.647 299.587 121.792 299.587 115.479C299.587 103.243 238.744 111.692 238.744 77.8003C238.744 72.9448 245.186 45.6566 281.603 45.6566C305.94 45.6566 316.408 59.4464 321.061 65.5644L321.687 66.3412L305.707 77.6162C305.707 77.6162 298.066 66.6326 281.603 66.6326Z" fill="#030319" />
            <ellipse cx="97.8957" cy="97.8954" rx="97.8957" ry="97.8954" fill="url(#svg-1137231340_6119_paint0_linear_1843_2573)" />
            <path d="M103.576 14.4118C115.249 13.8539 129.142 17.6986 139.282 23.2509C158.722 33.8511 173.055 51.8528 179.03 73.1714C184.904 94.1022 182.275 116.505 171.709 135.505C161.278 154.663 143.583 168.825 122.604 174.805C121.916 175 121.535 175.131 120.923 174.79C120.848 174.232 123.053 171.981 123.588 171.354C127.648 166.588 129.697 162.178 131.673 156.382C133.304 155.423 134.869 154.356 136.358 153.19C151.792 141.054 161.837 123.339 164.329 103.867C166.932 83.664 161.768 65.3031 149.385 49.2548C145.6 44.5826 141.241 40.4056 136.412 36.8219C127.789 30.443 117.883 26.3644 107.081 25.9036C100.34 25.6159 94.1717 26.5885 89.9416 32.5503C88.1358 35.1174 87.0577 38.1249 86.8214 41.2544C85.8581 52.6598 94.7935 61.1826 102.438 68.3351C106.731 72.3277 111.304 76.1609 115.634 80.1021C126.117 89.6427 137.49 100.106 139.627 114.873C140.71 122.355 139.833 129.826 137.214 136.929C136.785 138.093 136.144 140.229 135.444 141.211L135.214 141.233C134.907 140.566 134.342 137.129 134.064 136.042C133.36 133.295 132.371 130.526 131.084 127.972C123.12 112.161 107.759 101.092 95.0915 89.0304C83.0497 77.5651 70.841 66.3252 69.8719 48.4363C69.4109 39.9256 72.4487 31.2566 78.2811 25.0667C85.079 17.8519 93.8037 14.7104 103.576 14.4118Z" fill="white" />
            <path d="M91.5742 180.82C79.901 181.378 66.0082 177.534 55.8688 171.981C36.4285 161.381 22.0955 143.379 16.1206 122.061C10.246 101.13 12.8756 78.7274 23.4413 59.7273C33.8727 40.5694 51.5673 26.4075 72.5462 20.4273C73.234 20.2325 73.6158 20.1012 74.2273 20.442C74.3028 20.9998 72.097 23.2514 71.5628 23.8785C67.5026 28.6444 65.4533 33.0547 63.4777 38.8504C61.8468 39.8095 60.2815 40.8763 58.7919 42.042C43.3582 54.178 33.3134 71.8929 30.8211 91.3651C28.218 111.568 33.3828 129.929 45.765 145.977C49.5501 150.65 53.9092 154.827 58.7385 158.41C67.3615 164.789 77.2674 168.868 88.0694 169.329C94.8106 169.616 100.979 168.644 105.209 162.682C107.015 160.115 108.093 157.107 108.329 153.978C109.292 142.572 100.357 134.05 92.7125 126.897C88.4197 122.904 83.8462 119.071 79.5159 115.13C69.0339 105.589 57.6601 95.1262 55.5235 80.3593C54.4404 72.877 55.3169 65.4066 57.9365 58.3035C58.3658 57.1393 59.0062 55.0028 59.7064 54.0216L59.9363 53.9994C60.2437 54.6664 60.8081 58.1028 61.0866 59.1903C61.7902 61.9377 62.7798 64.7057 64.0662 67.2598C72.0303 83.0713 87.391 94.1406 100.059 106.202C112.101 117.667 124.309 128.907 125.278 146.796C125.739 155.307 122.702 163.976 116.869 170.165C110.071 177.38 101.347 180.522 91.5742 180.82Z" fill="white" />
            <defs>
              <linearGradient id="svg-1137231340_6119_paint0_linear_1843_2573" x1="97.8957" y1="0" x2="46.0375" y2="179.202" gradientUnits="userSpaceOnUse">
                <stop stopColor="#0F1AF1" />
                <stop offset="1" stopColor="#2E38F9" />
              </linearGradient>
            </defs>
          </svg>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" id="svg-1839680863_948">
            <path d="M9.90033 7.61699C10.967 7.66699 11.242 8.57533 11.2587 9.00033H12.7503C12.6837 7.35033 11.5087 6.34199 9.87533 6.34199C8.03366 6.34199 6.66699 7.50033 6.66699 10.117C6.66699 11.7337 7.44199 13.6503 9.86699 13.6503C11.717 13.6503 12.7087 12.2753 12.7337 11.192H11.242C11.217 11.6837 10.867 12.342 9.88366 12.392C8.79199 12.3587 8.33366 11.5087 8.33366 10.117C8.33366 7.70866 9.40033 7.63366 9.90033 7.61699ZM10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667Z" fill="#666D80" />
          </svg>
        </>
      </div>
      <>
        {/*$*/}
        <div data-framer-root="" className="framer-WAsBz framer-7KstD framer-rcOGl framer-tx7Wz framer-1pq6sho ambassador-s1">
          <div className="ssr-variant hidden-16m4leg">
            <div className="framer-xapynw-container hidden-1pq6sho hidden-1mdp0u4 ambassador-s2" data-framer-appear-id="xapynw">
              <div className="framer-8MFL4 framer-15zawlh framer-v-15zawlh ambassador-s3" data-framer-name="Desktop [Default Boxed]">
                <header className="framer-ooxjtq ambassador-s4" data-border="true" data-framer-name="Main Area">
                  <div className="framer-p578i7 ambassador-s5" data-framer-name="Background [Default]" />
                  <div className="framer-pc27k4 ambassador-s6" data-framer-name="Background [Boxed Mini]" />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div data-framer-component-type="SVG" data-framer-name="Logo + Logo Type" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1hjthz ambassador-s7" aria-hidden="true" />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav">
                      <div className="framer-1hg3ikx-container" data-framer-name="Menu [Desktop]" name="Menu [Desktop]">
                        <div name="Menu [Desktop]" className="framer-n0D3w framer-1itjusz framer-v-1itjusz ambassador-s8" data-framer-name="Menu">
                          {/*$*/}
                          <div className="framer-mquu2a-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq ambassador-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/accounts" tabIndex={0}>
                              <div className="framer-19g30xi ambassador-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text ambassador-s11">
                                  Accounts{' '}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1yixouk-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq ambassador-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-pay" tabIndex={0}>
                              <div className="framer-19g30xi ambassador-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text ambassador-s11">
                                  Scallop Pay
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-wi7xty-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq ambassador-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/cards" tabIndex={0}>
                              <div className="framer-19g30xi ambassador-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text ambassador-s11">
                                  Cards
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1tpzm7c-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq ambassador-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-plus" tabIndex={0}>
                              <div className="framer-19g30xi ambassador-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text ambassador-s11">
                                  Scallop+
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-u2qi4r-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq ambassador-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/helpcenter" tabIndex={0}>
                              <div className="framer-19g30xi ambassador-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text ambassador-s11">
                                  FAQs
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                    </nav>
                    <div className="framer-14uxsxw" data-framer-name="Menu Icon">
                      <div className="framer-16051d2" data-framer-name="QR Overlay Trigger" data-highlight="true" tabIndex={0}>
                        <div className="framer-168591e-container">
                          <div className="framer-wWHmH framer-ly6l8a framer-v-18roq29 ambassador-s12" data-border="true" data-framer-name="Variant 2" data-highlight="true" tabIndex={0}>
                            <div className="framer-1ebu3nm ambassador-s13 reveal" data-framer-component-type="RichTextContainer">
                              <p dir="auto" className="framer-text ambassador-s14">
                                Get Started
                              </p>
                            </div>
                            <div className="framer-1u4w7ze ambassador-s15 reveal" data-framer-component-type="RichTextContainer">
                              <p className="framer-text ambassador-s16">
                                Coming soon
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
            <div className="framer-xapynw-container hidden-1pq6sho hidden-1mdp0u4" data-framer-appear-id="xapynw">
              <div className="framer-8MFL4 framer-15zawlh framer-v-ewbo4l ambassador-s3" data-framer-name="Mobile">
                <header className="framer-ooxjtq ambassador-s17" data-border="true" data-framer-name="Main Area">
                  <div className="framer-p578i7 ambassador-s5" data-framer-name="Background [Default]" />
                  <div className="framer-pc27k4 ambassador-s6" data-framer-name="Background [Boxed Mini]" />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div data-framer-component-type="SVG" data-framer-name="Logo + Logo Type" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1hjthz ambassador-s7" aria-hidden="true" />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav" />
                    <div className="framer-14uxsxw" data-framer-name="Menu Icon">
                      <div className="framer-1yr51k6-container">
                        {/*$*/}
                        <div className="framer-OuhX3 framer-1ib4qbi framer-v-1ib4qbi ambassador-s18" data-framer-name="Mobile Menu" data-highlight="true" tabIndex={0}>
                          <div className="framer-1cux5of ambassador-s19" />
                          <div className="framer-1w1bul6 ambassador-s19" />
                          <div className="framer-1ku2ucf ambassador-s20" />
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="framer-spocda-container hidden-16m4leg ambassador-s2" data-framer-appear-id="spocda" id="spocda">
            <div className="ssr-variant hidden-1mdp0u4">
              <div className="framer-8MFL4 framer-15zawlh framer-v-15zawlh ambassador-s3" data-framer-name="Desktop [Default Boxed]">
                <header className="framer-ooxjtq ambassador-s4" data-border="true" data-framer-name="Main Area">
                  <div className="framer-p578i7 ambassador-s5" data-framer-name="Background [Default]" />
                  <div className="framer-pc27k4 ambassador-s6" data-framer-name="Background [Boxed Mini]" />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div data-framer-component-type="SVG" data-framer-name="Logo + Logo Type" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1hjthz ambassador-s7" aria-hidden="true" />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav">
                      <div className="framer-1hg3ikx-container" data-framer-name="Menu [Desktop]" name="Menu [Desktop]">
                        <div name="Menu [Desktop]" className="framer-n0D3w framer-1itjusz framer-v-1itjusz ambassador-s8" data-framer-name="Menu">
                          {/*$*/}
                          <div className="framer-mquu2a-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq ambassador-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/accounts" tabIndex={0}>
                              <div className="framer-19g30xi ambassador-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text ambassador-s11">
                                  Accounts{' '}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1yixouk-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq ambassador-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-pay" tabIndex={0}>
                              <div className="framer-19g30xi ambassador-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text ambassador-s11">
                                  Scallop Pay
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-wi7xty-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq ambassador-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/cards" tabIndex={0}>
                              <div className="framer-19g30xi ambassador-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text ambassador-s11">
                                  Cards
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1tpzm7c-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq ambassador-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-plus" tabIndex={0}>
                              <div className="framer-19g30xi ambassador-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text ambassador-s11">
                                  Scallop+
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-u2qi4r-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq ambassador-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/helpcenter" tabIndex={0}>
                              <div className="framer-19g30xi ambassador-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text ambassador-s11">
                                  FAQs
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                    </nav>
                    <div className="framer-14uxsxw" data-framer-name="Menu Icon">
                      <div className="framer-16051d2" data-framer-name="QR Overlay Trigger" data-highlight="true" tabIndex={0}>
                        <div className="framer-168591e-container">
                          <div className="framer-wWHmH framer-ly6l8a framer-v-18roq29 ambassador-s12" data-border="true" data-framer-name="Variant 2" data-highlight="true" tabIndex={0}>
                            <div className="framer-1ebu3nm ambassador-s13 reveal" data-framer-component-type="RichTextContainer">
                              <p dir="auto" className="framer-text ambassador-s14">
                                Get Started
                              </p>
                            </div>
                            <div className="framer-1u4w7ze ambassador-s15 reveal" data-framer-component-type="RichTextContainer">
                              <p className="framer-text ambassador-s16">
                                Coming soon
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
            <div className="ssr-variant hidden-16m4leg hidden-1pq6sho">
              <div className="framer-8MFL4 framer-15zawlh framer-v-15viyb0 ambassador-s3" data-framer-name="Desktop [Boxed Mini]">
                <header className="framer-ooxjtq ambassador-s21" data-border="true" data-framer-name="Main Area">
                  <div className="framer-p578i7 ambassador-s6" data-framer-name="Background [Default]" />
                  <div className="framer-pc27k4 ambassador-s5" data-framer-name="Background [Boxed Mini]" />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div data-framer-component-type="SVG" data-framer-name="Logo + Logo Type" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1hjthz ambassador-s7" aria-hidden="true" />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav">
                      <div className="framer-1hg3ikx-container" data-framer-name="Menu [Desktop]" name="Menu [Desktop]">
                        <div name="Menu [Desktop]" className="framer-n0D3w framer-1itjusz framer-v-1itjusz ambassador-s8" data-framer-name="Menu">
                          {/*$*/}
                          <div className="framer-mquu2a-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq ambassador-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/accounts" tabIndex={0}>
                              <div className="framer-19g30xi ambassador-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text ambassador-s11">
                                  Accounts{' '}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1yixouk-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq ambassador-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-pay" tabIndex={0}>
                              <div className="framer-19g30xi ambassador-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text ambassador-s11">
                                  Scallop Pay
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-wi7xty-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq ambassador-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/cards" tabIndex={0}>
                              <div className="framer-19g30xi ambassador-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text ambassador-s11">
                                  Cards
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1tpzm7c-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq ambassador-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-plus" tabIndex={0}>
                              <div className="framer-19g30xi ambassador-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text ambassador-s11">
                                  Scallop+
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-u2qi4r-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq ambassador-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/helpcenter" tabIndex={0}>
                              <div className="framer-19g30xi ambassador-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text ambassador-s11">
                                  FAQs
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                    </nav>
                    <div className="framer-14uxsxw" data-framer-name="Menu Icon">
                      <div className="framer-16051d2" data-framer-name="QR Overlay Trigger" data-highlight="true" tabIndex={0}>
                        <div className="framer-168591e-container">
                          <div className="framer-wWHmH framer-ly6l8a framer-v-18roq29 ambassador-s12" data-border="true" data-framer-name="Variant 2" data-highlight="true" tabIndex={0}>
                            <div className="framer-1ebu3nm ambassador-s13 reveal" data-framer-component-type="RichTextContainer">
                              <p dir="auto" className="framer-text ambassador-s14">
                                Get Started
                              </p>
                            </div>
                            <div className="framer-1u4w7ze ambassador-s15 reveal" data-framer-component-type="RichTextContainer">
                              <p className="framer-text ambassador-s16">
                                Coming soon
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="framer-1ap5btf hidden-1pq6sho hidden-16m4leg" data-framer-name="how-we-empower">
            <div className="ssr-variant">
              <div className="framer-1jpz7r3" data-framer-name="2 22">
                <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                  <img decoding="async" width="1840" height="2996" sizes="(min-width: 1440px) 460px, (max-width: 809.98px) max(460px, 588px), (min-width: 810px) and (max-width: 1439.98px) 460px" srcSet="/framerusercontent.com/images/1MWWxfPVQF38Vzf26CFjt43aAI.png 628w,/framerusercontent.com/images/1MWWxfPVQF38Vzf26CFjt43aAI.png 1257w,/framerusercontent.com/images/1MWWxfPVQF38Vzf26CFjt43aAI.png 1840w" src="/framerusercontent.com/images/1MWWxfPVQF38Vzf26CFjt43aAI.png" alt="" className="ambassador-s23" />
                </div>
              </div>
            </div>
            <div className="ssr-variant">
              <div className="framer-91w0gn" data-framer-name="2 23">
                <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                  <img decoding="async" width="3879" height="2247" sizes="(min-width: 1440px) 1293px, (max-width: 809.98px) 1293px, (min-width: 810px) and (max-width: 1439.98px) 1293px" srcSet="/framerusercontent.com/images/LLWQP2mk2txCfP8UH3N5GeTZ4.png 512w,/framerusercontent.com/images/LLWQP2mk2txCfP8UH3N5GeTZ4.png 1024w,/framerusercontent.com/images/LLWQP2mk2txCfP8UH3N5GeTZ4.png 2048w,/framerusercontent.com/images/LLWQP2mk2txCfP8UH3N5GeTZ4.png 3879w" src="/framerusercontent.com/images/LLWQP2mk2txCfP8UH3N5GeTZ4.png" alt="" className="ambassador-s23" />
                </div>
              </div>
            </div>
            <div className="framer-111v0o" data-framer-name="Frame 1707479890" />
            <div data-framer-component-type="SVG" data-framer-name="Ellipse 15021" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-a5xo03 ambassador-s24" aria-hidden="true">
              <div className="svgContainer ambassador-s25">
                <svg viewBox="0 0 13 11" className="ambassador-s26">
                  <use href="#svg-990040155_504" />
                </svg>
              </div>
            </div>
            <div className="framer-mye373" data-framer-name="Frame 1707479889">
              <div className="framer-dptyyo ambassador-s27 reveal" data-framer-name="How we empower you as a Scallop Ambassador" data-framer-component-type="RichTextContainer">
                <h3 className="framer-text framer-styles-preset-nhkkac ambassador-s28" data-styles-preset="cN9teShfm" dir="auto">
                  How we empower you as a Scallop Ambassador
                </h3>
              </div>
              <div className="framer-1c1u4pw" data-framer-name="Frame 1707479882">
                <div className="framer-1nw313h ambassador-s29 reveal" data-framer-name="Access to the Scallop App with global multi currency accounts" data-framer-component-type="RichTextContainer">
                  <p dir="auto" className="framer-text ambassador-s30">
                    Access to the Scallop App with global multi currency
                    accounts
                  </p>
                </div>
                <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-6hbqsb ambassador-s24" aria-hidden="true">
                  <div className="svgContainer ambassador-s25">
                    <svg viewBox="0 0 20 20" className="ambassador-s26">
                      <use href="#svg-1324802642_1218" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="framer-jilsvf" data-framer-name="Frame 1707479890">
                <div className="framer-169pfhe ambassador-s31 reveal" data-framer-name="Free virtual and physical debit cards for everyday spending" data-framer-component-type="RichTextContainer">
                  <p dir="auto" className="framer-text ambassador-s32">
                    Free virtual and physical debit cards for everyday spending
                  </p>
                </div>
                <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-e6tn6b ambassador-s24" aria-hidden="true">
                  <div className="svgContainer ambassador-s25">
                    <svg viewBox="0 0 20 20" className="ambassador-s26">
                      <use href="#svg-1324802642_1218" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="framer-121tii9" data-framer-name="Frame 1707479891">
                <div className="framer-1suifwp ambassador-s31 reveal" data-framer-name="Ambassadors benefit from our lowest fee structure" data-framer-component-type="RichTextContainer">
                  <p dir="auto" className="framer-text ambassador-s32">
                    Ambassadors benefit from our lowest fee structure
                  </p>
                </div>
                <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-ghz81q ambassador-s24" aria-hidden="true">
                  <div className="svgContainer ambassador-s25">
                    <svg viewBox="0 0 20 20" className="ambassador-s26">
                      <use href="#svg-1324802642_1218" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="framer-1youky0" data-framer-name="Frame 1707479892">
                <div className="framer-19li57f ambassador-s31 reveal" data-framer-name="Tailored referral opportunities designed to grow your community" data-framer-component-type="RichTextContainer">
                  <p dir="auto" className="framer-text ambassador-s32">
                    Tailored referral opportunities designed to grow your
                    community
                  </p>
                </div>
                <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-osll25 ambassador-s24" aria-hidden="true">
                  <div className="svgContainer ambassador-s25">
                    <svg viewBox="0 0 20 20" className="ambassador-s26">
                      <use href="#svg-1324802642_1218" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="framer-1vj5ex4" data-framer-name="Frame 1707479893">
                <div className="framer-ed9xez ambassador-s31 reveal" data-framer-name="Event support for meetups, workshops and community activations" data-framer-component-type="RichTextContainer">
                  <p dir="auto" className="framer-text ambassador-s32">
                    Event support for meetups, workshops and community
                    activations
                  </p>
                </div>
                <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-4dn6sw ambassador-s24" aria-hidden="true">
                  <div className="svgContainer ambassador-s25">
                    <svg viewBox="0 0 20 20" className="ambassador-s26">
                      <use href="#svg-1324802642_1218" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="framer-1106gj3" data-framer-name="Frame 1707479894">
                <div className="framer-mkbmx9 ambassador-s31 reveal" data-framer-name="Rewards based on real impact and meaningful contributions" data-framer-component-type="RichTextContainer">
                  <p dir="auto" className="framer-text ambassador-s32">
                    Rewards based on real impact and meaningful contributions
                  </p>
                </div>
                <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-iklg84 ambassador-s24" aria-hidden="true">
                  <div className="svgContainer ambassador-s25">
                    <svg viewBox="0 0 20 20" className="ambassador-s26">
                      <use href="#svg-1324802642_1218" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="framer-17bkgav" data-framer-name="Frame 1707479895">
                <div className="framer-1m6lyrg ambassador-s31 reveal" data-framer-name="Flexible collaboration built around your region and your personal goals" data-framer-component-type="RichTextContainer">
                  <p dir="auto" className="framer-text ambassador-s32">
                    Flexible collaboration built around your region and your
                    personal goals
                  </p>
                </div>
                <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1jf23gc ambassador-s24" aria-hidden="true">
                  <div className="svgContainer ambassador-s25">
                    <svg viewBox="0 0 20 20" className="ambassador-s26">
                      <use href="#svg-1324802642_1218" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="framer-1arlggk" data-framer-name="Frame 1707479896">
                <div className="framer-ghpjd2 ambassador-s31 reveal" data-framer-name="Direct contact with our team and access to early product feedback rounds" data-framer-component-type="RichTextContainer">
                  <p dir="auto" className="framer-text ambassador-s32">
                    Direct contact with our team and access to early product
                    feedback rounds
                  </p>
                </div>
                <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1v9foq9 ambassador-s24" aria-hidden="true">
                  <div className="svgContainer ambassador-s25">
                    <svg viewBox="0 0 20 20" className="ambassador-s26">
                      <use href="#svg-1324802642_1218" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="framer-dd6q4e" data-framer-name="Hero Main" id="accounts">
            <div className="framer-uu7fu3" data-framer-name="Hero" id="uu7fu3">
              <div className="framer-1se7l8a" data-framer-name="Hero Text">
                <div className="framer-18nc0fb" data-framer-name="Text">
                  <div className="framer-193m0rp reveal" data-framer-appear-id="193m0rp" data-framer-name="Description" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text ambassador-s33">
                      We are looking for you
                    </p>
                  </div>
                  <div className="framer-zrytc6">
                    <div className="ssr-variant hidden-1mdp0u4">
                      <div className="framer-gdhvun reveal" data-framer-appear-id="gdhvun" data-framer-name="Heading" data-framer-component-type="RichTextContainer">
                        <h1 className="framer-text framer-styles-preset-18sajzf ambassador-s34" data-styles-preset="nXmNeSqma" dir="auto">
                          Become a Scallop{' '}
                          <span className="framer-text ambassador-s35">
                            Brand
                          </span>
                        </h1>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-16m4leg hidden-1pq6sho">
                      <div className="framer-gdhvun reveal" data-framer-appear-id="gdhvun" data-framer-name="Heading" data-framer-component-type="RichTextContainer">
                        <h2 className="framer-text framer-styles-preset-120m1vw ambassador-s34" data-styles-preset="Sp_YUSQNX" dir="auto">
                          Become a Scallop{' '}
                          <span className="framer-text ambassador-s35">
                            Brand
                          </span>
                        </h2>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1mdp0u4">
                      <div className="framer-dqesqi reveal" data-framer-appear-id="dqesqi" data-framer-name="Heading" data-framer-component-type="RichTextContainer">
                        <h1 className="framer-text framer-styles-preset-18sajzf ambassador-s36" data-styles-preset="nXmNeSqma" dir="auto">
                          Ambassador
                        </h1>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-16m4leg hidden-1pq6sho">
                      <div className="framer-dqesqi reveal" data-framer-appear-id="dqesqi" data-framer-name="Heading" data-framer-component-type="RichTextContainer">
                        <h2 className="framer-text framer-styles-preset-120m1vw ambassador-s36" data-styles-preset="Sp_YUSQNX" dir="auto">
                          Ambassador
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div className="framer-etu9s7 reveal" data-framer-appear-id="etu9s7" data-framer-name="Description" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text ambassador-s37">
                      Grow with us and join an exciting journey into real world
                      finance
                    </p>
                  </div>
                </div>
              </div>
              {/*$*/}
              <a aria-label="a" className="framer-2zz3sx framer-1wtdeyf" data-border="true" data-framer-name="Primary / Medium" id="a" href="./ambassador#form">
                <div className="framer-h3o78l ambassador-s38 reveal" data-framer-component-type="RichTextContainer">
                  <p dir="auto" className="framer-text ambassador-s39">
                    Apply Now
                  </p>
                </div>
              </a>
              {/*/$*/}
            </div>
            <div className="framer-1014tos">
              <div className="framer-1t1y4p1">
                <div className="ssr-variant">
                  <div className="framer-13ro5f0">
                    <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                      <img decoding="async" width="368" height="558" sizes="(min-width: 1440px) 368px, (min-width: 810px) and (max-width: 1439.98px) 246.9255px, (max-width: 809.98px) 336px" srcSet="/framerusercontent.com/images/qumBQc9FAq0oMcumo3m7Ld3wng.png 368w" src="/framerusercontent.com/images/qumBQc9FAq0oMcumo3m7Ld3wng.png" alt="" className="ambassador-s40" />
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-1mdp0u4 hidden-16m4leg">
                  <div className="framer-r4m1wz">
                    <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                      <img decoding="async" width="368" height="271" src="/framerusercontent.com/images/p5VGBenmLpiT9IQKwAa4FHmBCEs.png" alt="" className="ambassador-s40" />
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-16m4leg hidden-1pq6sho">
                  <div className="framer-r4m1wz ambassador-s2">
                    <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                      <img decoding="async" width="368" height="271" src="/framerusercontent.com/images/p5VGBenmLpiT9IQKwAa4FHmBCEs.png" alt="" className="ambassador-s40" />
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                  <div className="framer-r4m1wz">
                    <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                      <img decoding="async" loading="lazy" width="368" height="271" src="/framerusercontent.com/images/p5VGBenmLpiT9IQKwAa4FHmBCEs.png" alt="" className="ambassador-s40" />
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-1mdp0u4 hidden-16m4leg">
                  <div className="framer-1weqh05">
                    <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                      <img decoding="async" width="368" height="271" src="/framerusercontent.com/images/UNMz8ZzLV1RmHGX5FrFSAVAifUE.png" alt="" className="ambassador-s40" />
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-16m4leg hidden-1pq6sho">
                  <div className="framer-1weqh05 ambassador-s2">
                    <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                      <img decoding="async" width="368" height="271" src="/framerusercontent.com/images/UNMz8ZzLV1RmHGX5FrFSAVAifUE.png" alt="" className="ambassador-s40" />
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                  <div className="framer-1weqh05">
                    <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                      <img decoding="async" loading="lazy" width="368" height="271" src="/framerusercontent.com/images/UNMz8ZzLV1RmHGX5FrFSAVAifUE.png" alt="" className="ambassador-s40" />
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-16m4leg">
                  <div className="framer-1iqs4ae">
                    <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                      <img decoding="async" width="368" height="325" src="/framerusercontent.com/images/mGTfDz5MEn32b6jW8VXhxRr0U.png" alt="" className="ambassador-s40" />
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                  <div className="framer-1iqs4ae">
                    <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                      <img decoding="async" loading="lazy" width="368" height="325" src="/framerusercontent.com/images/mGTfDz5MEn32b6jW8VXhxRr0U.png" alt="" className="ambassador-s40" />
                    </div>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div className="framer-1nn17rp">
                    <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                      <img decoding="async" width="1104" height="651" sizes="(min-width: 1440px) 368px, (min-width: 810px) and (max-width: 1439.98px) 244px, (max-width: 809.98px) 336px" srcSet="/framerusercontent.com/images/Ajv7AxMeG7lDPFPzB6YC9tgsQco.png 512w,/framerusercontent.com/images/Ajv7AxMeG7lDPFPzB6YC9tgsQco.png 1024w,/framerusercontent.com/images/Ajv7AxMeG7lDPFPzB6YC9tgsQco.png 1104w" src="/framerusercontent.com/images/Ajv7AxMeG7lDPFPzB6YC9tgsQco.png" alt="" className="ambassador-s40" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="framer-vvttpa" id="featuresnew">
            <div className="framer-r3223k ambassador-s41" data-framer-name="Text">
              <div className="framer-3xf9ex" data-framer-name="program-benifits">
                <div className="framer-6u274u" data-framer-name="Frame 11">
                  <div className="framer-thla0a" data-framer-name="Frame 8" />
                  <div className="ssr-variant hidden-16m4leg">
                    <div className="framer-118qauv ambassador-s27 reveal" data-framer-name="Basic Account \u2192 Heading 3 \u2192 Basic Account" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s42">
                        Refer friends
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                    <div className="framer-118qauv ambassador-s27 reveal" data-framer-name="Basic Account \u2192 Heading 3 \u2192 Basic Account" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s43">
                        Refer friends
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-16m4leg">
                    <div className="framer-o1wfg ambassador-s27 reveal" data-framer-name="Invite new Scallop App users and earn rewards for every successful referral" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s44">
                        Invite new Scallop App users and earn rewards for every
                        successful referral
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                    <div className="framer-o1wfg ambassador-s45 reveal" data-framer-name="Invite new Scallop App users and earn rewards for every successful referral" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s44">
                        Invite new Scallop App users and earn rewards for every
                        successful referral
                      </p>
                    </div>
                  </div>
                </div>
                <div className="framer-bdtess" data-framer-name="Frame 13">
                  <div className="ssr-variant hidden-16m4leg">
                    <div className="framer-1vqlopz ambassador-s27 reveal" data-framer-name="Basic Account \u2192 Heading 3 \u2192 Basic Account" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s42">
                        Exclusive access
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                    <div className="framer-1vqlopz ambassador-s27 reveal" data-framer-name="Basic Account \u2192 Heading 3 \u2192 Basic Account" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s43">
                        Exclusive access
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-16m4leg">
                    <div className="framer-mqo7pz ambassador-s27 reveal" data-framer-name="Early product features, limited merch and unique ambassador perks" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s44">
                        Early product features, limited merch and unique
                        ambassador perks
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                    <div className="framer-mqo7pz ambassador-s45 reveal" data-framer-name="Early product features, limited merch and unique ambassador perks" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s44">
                        Early product features, limited merch and unique
                        ambassador perks
                      </p>
                    </div>
                  </div>
                </div>
                <div className="framer-1v4op70" data-framer-name="Frame 9">
                  <div className="framer-fvzp4r" data-framer-name="Frame 8" />
                  <div className="ssr-variant hidden-16m4leg">
                    <div className="framer-1hlq9q3 ambassador-s27 reveal" data-framer-name="Basic Account \u2192 Heading 3 \u2192 Basic Account" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s42">
                        Grow your community
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                    <div className="framer-1hlq9q3 ambassador-s27 reveal" data-framer-name="Basic Account \u2192 Heading 3 \u2192 Basic Account" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s43">
                        Grow your community
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-16m4leg">
                    <div className="framer-1khdaoq ambassador-s27 reveal" data-framer-name="Tools, templates and direct support to build and scale your own community" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s44">
                        Tools, templates and direct support to build and scale
                        your own community
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                    <div className="framer-1khdaoq ambassador-s45 reveal" data-framer-name="Tools, templates and direct support to build and scale your own community" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s44">
                        Tools, templates and direct support to build and scale
                        your own community
                      </p>
                    </div>
                  </div>
                </div>
                <div className="framer-uxywhd" data-framer-name="Frame 12">
                  <div className="framer-th8mnz" data-framer-name="Frame 8" />
                  <div className="ssr-variant hidden-16m4leg">
                    <div className="framer-1ov0ydv ambassador-s27 reveal" data-framer-name="Basic Account \u2192 Heading 3 \u2192 Basic Account" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s42">
                        Earn rewards
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                    <div className="framer-1ov0ydv ambassador-s27 reveal" data-framer-name="Basic Account \u2192 Heading 3 \u2192 Basic Account" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s43">
                        Earn rewards
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-16m4leg">
                    <div className="framer-93s3ra ambassador-s27 reveal" data-framer-name="Get rewarded for events, activations and real community impact" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s44">
                        Get rewarded for events, activations and real community
                        impact
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                    <div className="framer-93s3ra ambassador-s45 reveal" data-framer-name="Get rewarded for events, activations and real community impact" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s44">
                        Get rewarded for events, activations and real community
                        impact
                      </p>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-16m4leg">
                  <div className="framer-1sw4lh1 ambassador-s45 reveal" data-framer-name="Program Benefits" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text ambassador-s46">
                      Program Benefits
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                  <div className="framer-1sw4lh1 ambassador-s45 reveal" data-framer-name="Program Benefits" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text ambassador-s47">
                      Program Benefits
                    </p>
                  </div>
                </div>
                <div className="framer-xetk7z hidden-1mdp0u4 hidden-16m4leg" data-framer-name="Frame 1707479899">
                  <div className="framer-44v5gb ambassador-s48" data-framer-name="image 1446">
                    <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                      <img decoding="async" loading="lazy" width="450" height="450" src="/framerusercontent.com/images/fwQv2U4tXbwNOkW6J2q9AWUU.png" alt="" className="ambassador-s40" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-4he7p2">
              <div className="framer-oesbfe" data-framer-name="who-youn-are">
                <div className="framer-4rzevh" data-framer-name="Frame 1707479889">
                  <div className="ssr-variant hidden-16m4leg">
                    <div className="framer-3xwpqq ambassador-s27 reveal" data-framer-name="Who you are" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s49">
                        Who you are
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                    <div className="framer-3xwpqq ambassador-s27 reveal" data-framer-name="Who you are" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s50">
                        Who you are
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1mdp0u4 hidden-16m4leg">
                    <div className="framer-pja6nt ambassador-s45 reveal" data-framer-name="We look for people who live in Web3 every day and want to bring real utility to their communities. If you enjoy helping others discover better financial tools and you like being part of a growing movement, you will feel at home here." data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s51">
                        We look for people who live in Web3 every day and want
                        to bring real utility to their communities. If you enjoy
                        helping others discover better financial tools and you
                        like being part of a growing movement, you will feel at
                        home here.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1pq6sho">
                    <div className="framer-pja6nt ambassador-s27 reveal" data-framer-name="We look for people who live in Web3 every day and want to bring real utility to their communities. If you enjoy helping others discover better financial tools and you like being part of a growing movement, you will feel at home here." data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s51">
                        We look for people who live in Web3 every day and want
                        to bring real utility to their communities. If you enjoy
                        helping others discover better financial tools and you
                        like being part of a growing movement, you will feel at
                        home here.
                      </p>
                    </div>
                  </div>
                  <div className="framer-eifdmg" data-framer-name="Frame 1707479882">
                    <div className="framer-jhdosx ambassador-s29 reveal" data-framer-name="You use crypto daily and look for real utility in everyday life" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s52">
                        You use digital assets daily and look for real
                        utility{' '}
                      </p>
                    </div>
                    <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-e9dxtl ambassador-s24" aria-hidden="true">
                      <div className="svgContainer ambassador-s25">
                        <svg viewBox="0 0 24 24" className="ambassador-s26">
                          <use href="#svg-392818195_1078" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="framer-lsgaw4" data-framer-name="Frame 1707479883">
                    <div className="ssr-variant hidden-1mdp0u4 hidden-16m4leg">
                      <div className="framer-7reh8 ambassador-s45 reveal" data-framer-name="You enjoy paying in stores, using transport, buying tickets or settling bills with digital assets" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You enjoy paying in stores, using transport, buying
                          tickets or settling bills with digital assets
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-16m4leg hidden-1pq6sho">
                      <div className="framer-7reh8 ambassador-s31 reveal" data-framer-name="You enjoy paying in stores, using transport, buying tickets or settling bills with digital assets" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You enjoy paying in stores, using transport, buying
                          tickets or settling bills with digital assets
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                      <div className="framer-7reh8 ambassador-s29 reveal" data-framer-name="You enjoy paying in stores, using transport, buying tickets or settling bills with digital assets" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You enjoy paying in stores, using transport, buying
                          tickets or settling bills with digital assets
                        </p>
                      </div>
                    </div>
                    <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1nozcpw ambassador-s24" aria-hidden="true">
                      <div className="svgContainer ambassador-s25">
                        <svg viewBox="0 0 24 24" className="ambassador-s26">
                          <use href="#svg-392818195_1078" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="framer-1iyma4s" data-framer-name="Frame 1707479884">
                    <div className="ssr-variant hidden-16m4leg">
                      <div className="framer-7zd1e1 ambassador-s45 reveal" data-framer-name="You are tech minded and enjoy giving clear and honest feedback that helps us improve" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You are tech minded and enjoy giving clear and honest
                          feedback that helps us improve
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                      <div className="framer-7zd1e1 ambassador-s29 reveal" data-framer-name="You are tech minded and enjoy giving clear and honest feedback that helps us improve" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You are tech minded and enjoy giving clear and honest
                          feedback that helps us improve
                        </p>
                      </div>
                    </div>
                    <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-8u7v6r ambassador-s24" aria-hidden="true">
                      <div className="svgContainer ambassador-s25">
                        <svg viewBox="0 0 24 24" className="ambassador-s26">
                          <use href="#svg-392818195_1078" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="framer-1wgnhu7" data-framer-name="Frame 1707479885">
                    <div className="ssr-variant hidden-1mdp0u4 hidden-16m4leg">
                      <div className="framer-11o3yr7 ambassador-s45 reveal" data-framer-name="You are a natural guide in your community and people trust your recommendations" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You are a natural guide in your community and people
                          trust your recommendations
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-16m4leg hidden-1pq6sho">
                      <div className="framer-11o3yr7 ambassador-s31 reveal" data-framer-name="You are a natural guide in your community and people trust your recommendations" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You are a natural guide in your community and people
                          trust your recommendations
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                      <div className="framer-11o3yr7 ambassador-s29 reveal" data-framer-name="You are a natural guide in your community and people trust your recommendations" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You are a natural guide in your community and people
                          trust your recommendations
                        </p>
                      </div>
                    </div>
                    <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-ent645 ambassador-s24" aria-hidden="true">
                      <div className="svgContainer ambassador-s25">
                        <svg viewBox="0 0 24 24" className="ambassador-s26">
                          <use href="#svg-392818195_1078" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="framer-q9zw5i" data-framer-name="Frame 1707479887">
                    <div className="ssr-variant hidden-1mdp0u4 hidden-16m4leg">
                      <div className="framer-2fl1d0 ambassador-s45 reveal" data-framer-name="You have hosted small meetups or events or you want to start building your own community" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You have hosted small meetups or events or you want to
                          start building your own community
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-16m4leg hidden-1pq6sho">
                      <div className="framer-2fl1d0 ambassador-s31 reveal" data-framer-name="You have hosted small meetups or events or you want to start building your own community" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You have hosted small meetups or events or you want to
                          start building your own community
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                      <div className="framer-2fl1d0 ambassador-s29 reveal" data-framer-name="You have hosted small meetups or events or you want to start building your own community" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You have hosted small meetups or events or you want to
                          start building your own community
                        </p>
                      </div>
                    </div>
                    <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-cm4h1t ambassador-s24" aria-hidden="true">
                      <div className="svgContainer ambassador-s25">
                        <svg viewBox="0 0 24 24" className="ambassador-s26">
                          <use href="#svg-392818195_1078" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="framer-d6vy73" data-framer-name="Frame 1707479888">
                    <div className="ssr-variant hidden-1mdp0u4 hidden-16m4leg">
                      <div className="framer-gu92wi ambassador-s45 reveal" data-framer-name="You want support for community activities, sponsorships or collaborations" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You want support for community activities,
                          sponsorships or collaborations
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-16m4leg hidden-1pq6sho">
                      <div className="framer-gu92wi ambassador-s31 reveal" data-framer-name="You want support for community activities, sponsorships or collaborations" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You want support for community activities,
                          sponsorships or collaborations
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                      <div className="framer-gu92wi ambassador-s29 reveal" data-framer-name="You want support for community activities, sponsorships or collaborations" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You want support for community activities,
                          sponsorships or collaborations
                        </p>
                      </div>
                    </div>
                    <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-qqxcny ambassador-s24" aria-hidden="true">
                      <div className="svgContainer ambassador-s25">
                        <svg viewBox="0 0 24 24" className="ambassador-s26">
                          <use href="#svg-392818195_1078" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="framer-hwoicz" data-framer-name="Frame 1707479889">
                    <div className="ssr-variant hidden-16m4leg">
                      <div className="framer-b9acmz ambassador-s45 reveal" data-framer-name="You enjoy working with emerging fintech and blockchain products that bring real change" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You enjoy working with emerging fintech and blockchain
                          products that bring real change
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                      <div className="framer-b9acmz ambassador-s29 reveal" data-framer-name="You enjoy working with emerging fintech and blockchain products that bring real change" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text ambassador-s52">
                          You enjoy working with emerging fintech and blockchain
                          products that bring real change
                        </p>
                      </div>
                    </div>
                    <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1n8h2qh ambassador-s24" aria-hidden="true">
                      <div className="svgContainer ambassador-s25">
                        <svg viewBox="0 0 24 24" className="ambassador-s26">
                          <use href="#svg-392818195_1078" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="framer-hfxmpg hidden-16m4leg" data-framer-name="Frame 1707479900">
                  <div className="ssr-variant hidden-1mdp0u4">
                    <div className="framer-1cusx45 ambassador-s48" data-framer-name="7 71">
                      <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                        <img decoding="async" loading="lazy" width="3840" height="2160" sizes="(min-width: 1440px) 1116px, (max-width: 809.98px) 1116px, (min-width: 810px) and (max-width: 1439.98px) 889px" srcSet="/framerusercontent.com/images/NAkTQMczJnHGjDAwsdYtUs3IjM.jpg 512w,/framerusercontent.com/images/NAkTQMczJnHGjDAwsdYtUs3IjM.jpg 1024w,/framerusercontent.com/images/NAkTQMczJnHGjDAwsdYtUs3IjM.jpg 2048w,/framerusercontent.com/images/NAkTQMczJnHGjDAwsdYtUs3IjM.jpg 3840w" src="/framerusercontent.com/images/NAkTQMczJnHGjDAwsdYtUs3IjM.jpg" alt="" className="ambassador-s40" />
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-16m4leg hidden-1pq6sho">
                    <div className="framer-1cusx45" data-framer-name="7 71">
                      <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                        <img decoding="async" loading="lazy" width="3840" height="2160" sizes="(min-width: 1440px) 1116px, (max-width: 809.98px) 1116px, (min-width: 810px) and (max-width: 1439.98px) 889px" srcSet="/framerusercontent.com/images/NAkTQMczJnHGjDAwsdYtUs3IjM.jpg 512w,/framerusercontent.com/images/NAkTQMczJnHGjDAwsdYtUs3IjM.jpg 1024w,/framerusercontent.com/images/NAkTQMczJnHGjDAwsdYtUs3IjM.jpg 2048w,/framerusercontent.com/images/NAkTQMczJnHGjDAwsdYtUs3IjM.jpg 3840w" src="/framerusercontent.com/images/NAkTQMczJnHGjDAwsdYtUs3IjM.jpg" alt="" className="ambassador-s40" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="framer-y2rrzn" />
              </div>
            </div>
            <div className="framer-1bv3g9a hidden-1mdp0u4" data-framer-name="how-we-empower">
              <div className="ssr-variant">
                <div className="framer-hi4rac" data-framer-name="2 22">
                  <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                    <img decoding="async" width="1840" height="2996" sizes="(min-width: 1440px) 460px, (max-width: 809.98px) max(460px, 588px), (min-width: 810px) and (max-width: 1439.98px) 460px" srcSet="/framerusercontent.com/images/1MWWxfPVQF38Vzf26CFjt43aAI.png 628w,/framerusercontent.com/images/1MWWxfPVQF38Vzf26CFjt43aAI.png 1257w,/framerusercontent.com/images/1MWWxfPVQF38Vzf26CFjt43aAI.png 1840w" src="/framerusercontent.com/images/1MWWxfPVQF38Vzf26CFjt43aAI.png" alt="" className="ambassador-s23" />
                  </div>
                </div>
              </div>
              <div className="framer-132i9vp hidden-16m4leg ambassador-s53" data-framer-name="2 23">
                <div data-framer-background-image-wrapper="true" className="ambassador-s22">
                  <img decoding="async" width="3879" height="2247" sizes="(min-width: 1440px) 1293px, (max-width: 809.98px) 1293px, (min-width: 810px) and (max-width: 1439.98px) 1293px" srcSet="/framerusercontent.com/images/LLWQP2mk2txCfP8UH3N5GeTZ4.png 512w,/framerusercontent.com/images/LLWQP2mk2txCfP8UH3N5GeTZ4.png 1024w,/framerusercontent.com/images/LLWQP2mk2txCfP8UH3N5GeTZ4.png 2048w,/framerusercontent.com/images/LLWQP2mk2txCfP8UH3N5GeTZ4.png 3879w" src="/framerusercontent.com/images/LLWQP2mk2txCfP8UH3N5GeTZ4.png" alt="" className="ambassador-s23" />
                </div>
              </div>
              <div className="framer-di5ve" data-framer-name="Frame 1707479890" />
              <div data-framer-component-type="SVG" data-framer-name="Ellipse 15021" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1p6huad ambassador-s24" aria-hidden="true">
                <div className="svgContainer ambassador-s25">
                  <svg viewBox="0 0 13 11" className="ambassador-s26">
                    <use href="#svg-990040155_504" />
                  </svg>
                </div>
              </div>
              <div className="framer-fv2zdp" data-framer-name="Frame 1707479889">
                <div className="ssr-variant hidden-16m4leg">
                  <div className="framer-z6buej ambassador-s45 reveal" data-framer-name="How we empower you as a Scallop Ambassador" data-framer-component-type="RichTextContainer">
                    <h3 className="framer-text framer-styles-preset-nhkkac ambassador-s28" data-styles-preset="cN9teShfm" dir="auto">
                      How we empower you as a Scallop Ambassador
                    </h3>
                  </div>
                </div>
                <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                  <div className="framer-z6buej ambassador-s27 reveal" data-framer-name="How we empower you as a Scallop Ambassador" data-framer-component-type="RichTextContainer">
                    <h3 dir="auto" className="framer-text ambassador-s54">
                      How we empower you as a Scallop Ambassador
                    </h3>
                  </div>
                </div>
                <div className="framer-2ibdfn" data-framer-name="Frame 1707479882">
                  <div className="ssr-variant hidden-16m4leg">
                    <div className="framer-1178jmi ambassador-s29 reveal" data-framer-name="Access to the Scallop App with global multi currency accounts" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s30">
                        Access to the Scallop App with global multi currency
                        accounts
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                    <div className="framer-1178jmi ambassador-s31 reveal" data-framer-name="Access to the Scallop App with global multi currency accounts" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s30">
                        Access to the Scallop App with global multi currency
                        accounts
                      </p>
                    </div>
                  </div>
                  <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1rweyt7 ambassador-s24" aria-hidden="true">
                    <div className="svgContainer ambassador-s25">
                      <svg viewBox="0 0 20 20" className="ambassador-s26">
                        <use href="#svg-1324802642_1218" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="framer-1va619k" data-framer-name="Frame 1707479890">
                  <div className="framer-12j82qk ambassador-s29 reveal" data-framer-name="Free virtual and physical debit cards for everyday spending" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text ambassador-s32">
                      Free virtual and physical debit cards for everyday
                      spending
                    </p>
                  </div>
                  <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-n8t9vq ambassador-s24" aria-hidden="true">
                    <div className="svgContainer ambassador-s25">
                      <svg viewBox="0 0 20 20" className="ambassador-s26">
                        <use href="#svg-1324802642_1218" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="framer-1iqpx2b" data-framer-name="Frame 1707479891">
                  <div className="ssr-variant hidden-16m4leg">
                    <div className="framer-bslkiv ambassador-s29 reveal" data-framer-name="Ambassadors benefit from our lowest fee structure" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s32">
                        Ambassadors benefit from our lowest fee structure
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                    <div className="framer-bslkiv ambassador-s31 reveal" data-framer-name="Ambassadors benefit from our lowest fee structure" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text ambassador-s32">
                        Ambassadors benefit from our lowest fee structure
                      </p>
                    </div>
                  </div>
                  <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-uvqzth ambassador-s24" aria-hidden="true">
                    <div className="svgContainer ambassador-s25">
                      <svg viewBox="0 0 20 20" className="ambassador-s26">
                        <use href="#svg-1324802642_1218" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="framer-187nrgh" data-framer-name="Frame 1707479892">
                  <div className="framer-1n27aca ambassador-s29 reveal" data-framer-name="Tailored referral opportunities designed to grow your community" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text ambassador-s32">
                      Tailored referral opportunities designed to grow your
                      community
                    </p>
                  </div>
                  <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-swnwe7 ambassador-s24" aria-hidden="true">
                    <div className="svgContainer ambassador-s25">
                      <svg viewBox="0 0 20 20" className="ambassador-s26">
                        <use href="#svg-1324802642_1218" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="framer-9jx4k1" data-framer-name="Frame 1707479893">
                  <div className="framer-5ludtx ambassador-s29 reveal" data-framer-name="Event support for meetups, workshops and community activations" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text ambassador-s32">
                      Event support for meetups, workshops and community
                      activations
                    </p>
                  </div>
                  <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-bt4ced ambassador-s24" aria-hidden="true">
                    <div className="svgContainer ambassador-s25">
                      <svg viewBox="0 0 20 20" className="ambassador-s26">
                        <use href="#svg-1324802642_1218" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="framer-zqeuqo" data-framer-name="Frame 1707479894">
                  <div className="framer-bs6ska ambassador-s29 reveal" data-framer-name="Rewards based on real impact and meaningful contributions" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text ambassador-s32">
                      Rewards based on real impact and meaningful contributions
                    </p>
                  </div>
                  <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-11smuoo ambassador-s24" aria-hidden="true">
                    <div className="svgContainer ambassador-s25">
                      <svg viewBox="0 0 20 20" className="ambassador-s26">
                        <use href="#svg-1324802642_1218" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="framer-k4hbfa" data-framer-name="Frame 1707479895">
                  <div className="framer-bs0f5f ambassador-s29 reveal" data-framer-name="Flexible collaboration built around your region and your personal goals" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text ambassador-s32">
                      Flexible collaboration built around your region and your
                      personal goals
                    </p>
                  </div>
                  <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1bdzop5 ambassador-s24" aria-hidden="true">
                    <div className="svgContainer ambassador-s25">
                      <svg viewBox="0 0 20 20" className="ambassador-s26">
                        <use href="#svg-1324802642_1218" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="framer-7b0sbj" data-framer-name="Frame 1707479896">
                  <div className="framer-1onng09 ambassador-s29 reveal" data-framer-name="Direct contact with our team and access to early product feedback rounds" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text ambassador-s32">
                      Direct contact with our team and access to early product
                      feedback rounds
                    </p>
                  </div>
                  <div data-framer-component-type="SVG" data-framer-name="Frame" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-8xllfz ambassador-s24" aria-hidden="true">
                    <div className="svgContainer ambassador-s25">
                      <svg viewBox="0 0 20 20" className="ambassador-s26">
                        <use href="#svg-1324802642_1218" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="framer-12shauw" data-framer-name="CTA" id="form">
            <form className="framer-1v120wa">
              <div className="ssr-variant hidden-16m4leg">
                <div className="framer-17ec80f ambassador-s38 reveal" data-framer-name="Heading" data-framer-component-type="RichTextContainer">
                  <h3 className="framer-text framer-styles-preset-nhkkac ambassador-s55" data-styles-preset="cN9teShfm" dir="auto">
                    Application Form
                  </h3>
                </div>
              </div>
              <div className="ssr-variant hidden-1mdp0u4 hidden-1pq6sho">
                <div className="framer-17ec80f ambassador-s38 reveal" data-framer-name="Heading" data-framer-component-type="RichTextContainer">
                  <h3 dir="auto" className="framer-text ambassador-s56">
                    Application Form
                  </h3>
                </div>
              </div>
              <label className="framer-ou4t0b">
                <div className="framer-tgm7ro ambassador-s38 reveal" data-framer-name="Text" data-framer-component-type="RichTextContainer">
                  <p dir="auto" className="framer-text ambassador-s57">
                    Name
                  </p>
                </div>
                <div className="framer-form-text-input framer-form-input-wrapper framer-sb85jg framer-form-text-input-type">
                  <input type="text" required name="Name" placeholder="Enter your name" className="framer-form-input framer-form-input-empty" value="" />
                </div>
              </label>
              <label className="framer-85hky4">
                <div className="framer-1jx2bjk ambassador-s38 reveal" data-framer-name="Text" data-framer-component-type="RichTextContainer">
                  <p dir="auto" className="framer-text ambassador-s57">
                    Email
                  </p>
                </div>
                <div className="framer-form-text-input framer-form-input-wrapper framer-1o8a2i7">
                  <input type="email" required name="Email" placeholder="Enter your email" className="framer-form-input framer-form-input-empty" value="" />
                </div>
              </label>
              <div className="framer-1y4w0ob-container" data-code-component-plugin-id="84d4c1">
                {/*$*/}
                <div aria-disabled="false" className="ambassador-s58">
                  <p className="ambassador-s59">Select Country</p>
                  <div className="ambassador-s60">
                    <select aria-label="Select Country" className="ambassador-s61">
                      <option value="" disabled={true} selected={true}>
                        Select a country&hellip;
                      </option>
                      <option value="Afghanistan">Afghanistan</option>
                      <option value="Albania">Albania</option>
                      <option value="Algeria">Algeria</option>
                      <option value="Andorra">Andorra</option>
                      <option value="Angola">Angola</option>
                      <option value="Antigua and Barbuda">
                        Antigua and Barbuda
                      </option>
                      <option value="Argentina">Argentina</option>
                      <option value="Armenia">Armenia</option>
                      <option value="Australia">Australia</option>
                      <option value="Austria">Austria</option>
                      <option value="Azerbaijan">Azerbaijan</option>
                      <option value="Bahamas">Bahamas</option>
                      <option value="Bahrain">Bahrain</option>
                      <option value="Bangladesh">Bangladesh</option>
                      <option value="Barbados">Barbados</option>
                      <option value="Belarus">Belarus</option>
                      <option value="Belgium">Belgium</option>
                      <option value="Belize">Belize</option>
                      <option value="Benin">Benin</option>
                      <option value="Bhutan">Bhutan</option>
                      <option value="Bolivia">Bolivia</option>
                      <option value="Bosnia and Herzegovina">
                        Bosnia and Herzegovina
                      </option>
                      <option value="Botswana">Botswana</option>
                      <option value="Brazil">Brazil</option>
                      <option value="Brunei">Brunei</option>
                      <option value="Bulgaria">Bulgaria</option>
                      <option value="Burkina Faso">Burkina Faso</option>
                      <option value="Burundi">Burundi</option>
                      <option value="Cabo Verde">Cabo Verde</option>
                      <option value="Cambodia">Cambodia</option>
                      <option value="Cameroon">Cameroon</option>
                      <option value="Canada">Canada</option>
                      <option value="Central African Republic">
                        Central African Republic
                      </option>
                      <option value="Chad">Chad</option>
                      <option value="Chile">Chile</option>
                      <option value="China">China</option>
                      <option value="Colombia">Colombia</option>
                      <option value="Comoros">Comoros</option>
                      <option value="Congo, Democratic Republic of the">
                        Congo, Democratic Republic of the
                      </option>
                      <option value="Congo, Republic of the">
                        Congo, Republic of the
                      </option>
                      <option value="Costa Rica">Costa Rica</option>
                      <option value="C\xF4te d\u2019Ivoire">
                        C&ocirc;te d&rsquo;Ivoire
                      </option>
                      <option value="Croatia">Croatia</option>
                      <option value="Cuba">Cuba</option>
                      <option value="Cyprus">Cyprus</option>
                      <option value="Czechia">Czechia</option>
                      <option value="Denmark">Denmark</option>
                      <option value="Djibouti">Djibouti</option>
                      <option value="Dominica">Dominica</option>
                      <option value="Dominican Republic">
                        Dominican Republic
                      </option>
                      <option value="Ecuador">Ecuador</option>
                      <option value="Egypt">Egypt</option>
                      <option value="El Salvador">El Salvador</option>
                      <option value="Equatorial Guinea">
                        Equatorial Guinea
                      </option>
                      <option value="Eritrea">Eritrea</option>
                      <option value="Estonia">Estonia</option>
                      <option value="Eswatini">Eswatini</option>
                      <option value="Ethiopia">Ethiopia</option>
                      <option value="Fiji">Fiji</option>
                      <option value="Finland">Finland</option>
                      <option value="France">France</option>
                      <option value="Gabon">Gabon</option>
                      <option value="Gambia">Gambia</option>
                      <option value="Georgia">Georgia</option>
                      <option value="Germany">Germany</option>
                      <option value="Ghana">Ghana</option>
                      <option value="Greece">Greece</option>
                      <option value="Grenada">Grenada</option>
                      <option value="Guatemala">Guatemala</option>
                      <option value="Guinea">Guinea</option>
                      <option value="Guinea-Bissau">Guinea-Bissau</option>
                      <option value="Guyana">Guyana</option>
                      <option value="Haiti">Haiti</option>
                      <option value="Honduras">Honduras</option>
                      <option value="Hungary">Hungary</option>
                      <option value="Iceland">Iceland</option>
                      <option value="India">India</option>
                      <option value="Indonesia">Indonesia</option>
                      <option value="Iran">Iran</option>
                      <option value="Iraq">Iraq</option>
                      <option value="Ireland">Ireland</option>
                      <option value="Israel">Israel</option>
                      <option value="Italy">Italy</option>
                      <option value="Jamaica">Jamaica</option>
                      <option value="Japan">Japan</option>
                      <option value="Jordan">Jordan</option>
                      <option value="Kazakhstan">Kazakhstan</option>
                      <option value="Kenya">Kenya</option>
                      <option value="Kiribati">Kiribati</option>
                      <option value="Korea, North">Korea, North</option>
                      <option value="Korea, South">Korea, South</option>
                      <option value="Kosovo">Kosovo</option>
                      <option value="Kuwait">Kuwait</option>
                      <option value="Kyrgyzstan">Kyrgyzstan</option>
                      <option value="Laos">Laos</option>
                      <option value="Latvia">Latvia</option>
                      <option value="Lebanon">Lebanon</option>
                      <option value="Lesotho">Lesotho</option>
                      <option value="Liberia">Liberia</option>
                      <option value="Libya">Libya</option>
                      <option value="Liechtenstein">Liechtenstein</option>
                      <option value="Lithuania">Lithuania</option>
                      <option value="Luxembourg">Luxembourg</option>
                      <option value="Madagascar">Madagascar</option>
                      <option value="Malawi">Malawi</option>
                      <option value="Malaysia">Malaysia</option>
                      <option value="Maldives">Maldives</option>
                      <option value="Mali">Mali</option>
                      <option value="Malta">Malta</option>
                      <option value="Marshall Islands">Marshall Islands</option>
                      <option value="Mauritania">Mauritania</option>
                      <option value="Mauritius">Mauritius</option>
                      <option value="Mexico">Mexico</option>
                      <option value="Micronesia">Micronesia</option>
                      <option value="Moldova">Moldova</option>
                      <option value="Monaco">Monaco</option>
                      <option value="Mongolia">Mongolia</option>
                      <option value="Montenegro">Montenegro</option>
                      <option value="Morocco">Morocco</option>
                      <option value="Mozambique">Mozambique</option>
                      <option value="Myanmar (Burma)">Myanmar (Burma)</option>
                      <option value="Namibia">Namibia</option>
                      <option value="Nauru">Nauru</option>
                      <option value="Nepal">Nepal</option>
                      <option value="Netherlands">Netherlands</option>
                      <option value="New Zealand">New Zealand</option>
                      <option value="Nicaragua">Nicaragua</option>
                      <option value="Niger">Niger</option>
                      <option value="Nigeria">Nigeria</option>
                      <option value="North Macedonia">North Macedonia</option>
                      <option value="Norway">Norway</option>
                      <option value="Oman">Oman</option>
                      <option value="Pakistan">Pakistan</option>
                      <option value="Palau">Palau</option>
                      <option value="Palestine">Palestine</option>
                      <option value="Panama">Panama</option>
                      <option value="Papua New Guinea">Papua New Guinea</option>
                      <option value="Paraguay">Paraguay</option>
                      <option value="Peru">Peru</option>
                      <option value="Philippines">Philippines</option>
                      <option value="Poland">Poland</option>
                      <option value="Portugal">Portugal</option>
                      <option value="Qatar">Qatar</option>
                      <option value="Romania">Romania</option>
                      <option value="Russia">Russia</option>
                      <option value="Rwanda">Rwanda</option>
                      <option value="Saint Kitts and Nevis">
                        Saint Kitts and Nevis
                      </option>
                      <option value="Saint Lucia">Saint Lucia</option>
                      <option value="Saint Vincent and the Grenadines">
                        Saint Vincent and the Grenadines
                      </option>
                      <option value="Samoa">Samoa</option>
                      <option value="San Marino">San Marino</option>
                      <option value="Sao Tome and Principe">
                        Sao Tome and Principe
                      </option>
                      <option value="Saudi Arabia">Saudi Arabia</option>
                      <option value="Senegal">Senegal</option>
                      <option value="Serbia">Serbia</option>
                      <option value="Seychelles">Seychelles</option>
                      <option value="Sierra Leone">Sierra Leone</option>
                      <option value="Singapore">Singapore</option>
                      <option value="Slovakia">Slovakia</option>
                      <option value="Slovenia">Slovenia</option>
                      <option value="Solomon Islands">Solomon Islands</option>
                      <option value="Somalia">Somalia</option>
                      <option value="South Africa">South Africa</option>
                      <option value="South Sudan">South Sudan</option>
                      <option value="Spain">Spain</option>
                      <option value="Sri Lanka">Sri Lanka</option>
                      <option value="Sudan">Sudan</option>
                      <option value="Suriname">Suriname</option>
                      <option value="Sweden">Sweden</option>
                      <option value="Switzerland">Switzerland</option>
                      <option value="Syria">Syria</option>
                      <option value="Taiwan">Taiwan</option>
                      <option value="Tajikistan">Tajikistan</option>
                      <option value="Tanzania">Tanzania</option>
                      <option value="Thailand">Thailand</option>
                      <option value="Timor-Leste">Timor-Leste</option>
                      <option value="Togo">Togo</option>
                      <option value="Tonga">Tonga</option>
                      <option value="Trinidad and Tobago">
                        Trinidad and Tobago
                      </option>
                      <option value="Tunisia">Tunisia</option>
                      <option value="Turkey">Turkey</option>
                      <option value="Turkmenistan">Turkmenistan</option>
                      <option value="Tuvalu">Tuvalu</option>
                      <option value="Uganda">Uganda</option>
                      <option value="Ukraine">Ukraine</option>
                      <option value="United Arab Emirates">
                        United Arab Emirates
                      </option>
                      <option value="United Kingdom">United Kingdom</option>
                      <option value="United States">United States</option>
                      <option value="Uruguay">Uruguay</option>
                      <option value="Uzbekistan">Uzbekistan</option>
                      <option value="Vanuatu">Vanuatu</option>
                      <option value="Vatican City">Vatican City</option>
                      <option value="Venezuela">Venezuela</option>
                      <option value="Vietnam">Vietnam</option>
                      <option value="Yemen">Yemen</option>
                      <option value="Zambia">Zambia</option>
                      <option value="Zimbabwe">Zimbabwe</option>
                    </select>
                    <svg viewBox="0 0 24 24" aria-hidden="true" className="ambassador-s62">
                      <path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" strokeWidth={2.25} strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                </div>
                {/*/$*/}
              </div>
              <label className="framer-kgmi4k">
                <div className="framer-1toy5wg ambassador-s38 reveal" data-framer-component-type="RichTextContainer">
                  <p dir="auto" className="framer-text ambassador-s63">
                    Select Social Account
                  </p>
                </div>
                <div className="framer-form-input-wrapper framer-form-select-wrapper framer-xm2ghm">
                  <select name="Location" required className="framer-form-input">
                    <option value="" disabled={true} selected={true}>
                      Select Account
                    </option>
                    <option value="Facebook">Facebook</option>
                    <option value="Instagram">Instagram</option>
                    <option value="X">X</option>
                  </select>
                </div>
              </label>
              <label className="framer-autal4">
                <div className="framer-1jev7fa ambassador-s38 reveal" data-framer-name="Text" data-framer-component-type="RichTextContainer">
                  <p dir="auto" className="framer-text ambassador-s57">
                    Link
                  </p>
                </div>
                <div className="framer-form-text-input framer-form-input-wrapper framer-a6ya54">
                  <input type="url" required name="Name" placeholder="Enter social media link" className="framer-form-input framer-form-input-empty" value="" />
                </div>
              </label>
              <label className="framer-bqdh03">
                <div className="framer-y7cean ambassador-s38 reveal" data-framer-name="Text" data-framer-component-type="RichTextContainer">
                  <p dir="auto" className="framer-text ambassador-s57">
                    About You
                  </p>
                </div>
                <div className="framer-form-text-input framer-form-input-wrapper framer-1rthi02 framer-form-textarea-input-type">
                  <textarea required name="Message" placeholder="Enter your message" className="framer-form-input" />
                </div>
              </label>
              <div className="ssr-variant">
                <div className="framer-3duouz-container">
                  <button type="submit" className="framer-c0vU2 framer-qrrnop framer-v-qrrnop ambassador-s64" data-framer-name="Default" data-highlight="true" data-reset="button" tabIndex={0}>
                    <div className="framer-12x6z4k" data-framer-name="Container">
                      <div className="framer-9o6e5k ambassador-s65 reveal" data-framer-name="Text" data-framer-component-type="RichTextContainer">
                        <p className="framer-text ambassador-s66">Submit</p>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
              <input type="text" name="website" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="ambassador-s67" />
              <input type="text" name="company" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="ambassador-s67" />
              <input type="text" name="message" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="ambassador-s67" />
              <input type="text" name="subject" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="ambassador-s67" />
              <input type="text" name="title" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="ambassador-s67" />
              <input type="text" name="description" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="ambassador-s67" />
              <input type="text" name="feedback" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="ambassador-s67" />
              <input type="text" name="notes" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="ambassador-s67" />
              <input type="text" name="details" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="ambassador-s67" />
              <input type="text" name="remarks" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="ambassador-s67" />
              <input type="text" name="comments" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="ambassador-s67" />
            </form>
          </div>
          <div className="framer-1ouqo9z-container">
              <div className="ssr-variant hidden-1kqrdcg hidden-15k5156">
                <div className="framer-1hodcae-container">
                   <Footer />
                </div>
              </div>
             
            </div>
        </div>
        <div id="overlay" />
        {/*/$*/}
      </>
    </div>;
}
export default Ambassador;